import { SVG_ShiftX } from "./SVG_ShiftX";
import { SVG_ShiftY } from "./SVG_ShiftY";
import { SVG_GetUniqueID } from "./SVG_GetUniqueID";
import { SVG_AddGradient } from "./SVG_AddGradient";
import { NS_SVG } from "../constants";

export function SVG_FillRect(x, y, width, height, fillColor, fillColor2, svgElement) {
  x = SVG_ShiftX(x, svgElement);
  y = SVG_ShiftY(y, svgElement);

  var rectObj = document.createElementNS(NS_SVG, "rect");
  rectObj.setAttribute("x", x);
  rectObj.setAttribute("y", y);
  rectObj.setAttribute("width", width);
  rectObj.setAttribute("height", height);

  if (fillColor2 != null) {
    var idStr = SVG_GetUniqueID("gradient");
    SVG_AddGradient(idStr, fillColor, fillColor2, svgElement);
    var gradientIDString = "url(#" + idStr + ")";
    //TODO: form up the ID string as the url#gradient construct
    rectObj.setAttribute("fill", gradientIDString);
  } else rectObj.setAttribute("fill", fillColor);

  svgElement.appendChild(rectObj);
}
